import { createFileRoute } from '@tanstack/react-router'

import DetailPetaniPage from '@/components/pages/backoffice/_klb-petani/_petani/_$petaniId/containers/DetailPetaniPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/petani/$petaniId/'
)({
  component: DetailPetaniPage
})
